module.exports = __webpack_public_path__ + "img/inicio.d6887ee3.svg";